import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {setActiveChannel} from '../../ducks/channels';

import Dropdown from '../../components/dropdown/Dropdown';

@connect(({channels}) => ({...channels}))
export default class ChannelDropdown extends React.PureComponent {
  static channelName = {
    eu: 'Europe',
    us: 'United States'
  };

  onChannelSelected = (channel) => {
    const {dispatch, onChannelSelected} = this.props;

    dispatch(setActiveChannel(channel));
    onChannelSelected && onChannelSelected(channel);
  };

  render() {
    const {activeChannel, availableChannels, mobile} = this.props;

    return (
      <Dropdown
        value={activeChannel}
        onChange={this.onChannelSelected}
        mobile={mobile}
      >
        {Object.keys(availableChannels).map((channel => (
          <Dropdown.Item
            key={channel}
            value={channel}
          >
            {ChannelDropdown.channelName[channel]}
          </Dropdown.Item>
        )))}
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelDropdown.js